export default class SymmetricMeshBuilder {
    constructor(game) {
        this.game = game;
    }
    build(meshSettings) {
        let vertices = [...meshSettings.vertices];
        let mirroredTriangles;
        let mirroredIndexBySource = new Map();
        meshSettings.vertices.forEach((v, i) => {
            if (v[0] === 0) {
                mirroredIndexBySource.set(i, i);
                return;
            }
            mirroredIndexBySource.set(i, vertices.length);
            vertices.push([-v[0], v[1], v[2]]);
        });
        mirroredTriangles = meshSettings.triangles.map(([a, b, c]) => [
            mirroredIndexBySource.get(a),
            mirroredIndexBySource.get(c),
            mirroredIndexBySource.get(b),
        ]);
        const newVertices = vertices.map((v) => this.game.p5.createVector(v[0] * meshSettings.scale[0], v[1] * meshSettings.scale[1], v[2] * meshSettings.scale[2]));
        const newTriangles = [...meshSettings.triangles, ...mirroredTriangles];
        return {
            x: meshSettings.x,
            y: meshSettings.y,
            z: meshSettings.z,
            vertices: newVertices,
            triangles: newTriangles,
        };
    }
}
